import Vue from "vue";
import VueMask from "v-mask";

Vue.use(VueMask);

export default {
  DATE: "##/##/####",
  TIME: "##:##",
  CARD_NUMBER: "#### #### #### ####",
  CARD_EXPIRY_DATE: "##/##",
  CARD_SECURITY_CODE: "###?",
  CELLPHONE: "(##) #####-####",
  CNPJ: "NN.NNN.NNN/####-##",
  ZIPCODE: "##.###-###",
  CPF: "###.###.###-##",
};
